{
  "version": 1,
  "asset_id": "607039da-4a34-4c4e-b869-a9ab0c4eef31",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/607039da-4a34-4c4e-b869-a9ab0c4eef31/lodge-porch-v2.png",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/607039da-4a34-4c4e-b869-a9ab0c4eef31/lodge-porch-v2.png",
  "original_filename": "lodge-porch-v2.png",
  "size": 2309351,
  "content_type": "image/png",
  "created_at": "2026-07-02T23:04:49Z"
}
